import React, {Component} from 'react';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import PropTypes from 'prop-types';
import SafeDateTimeParser from "../../Etc/SafeDateTimeParser";
import './PlannerDayCalendar.css';

// Setup the localizer by providing the moment (or globalize) Object
// to the correct localizer.
BigCalendar.momentLocalizer(moment); // or globalizeLocalizer

export default class PlannerDayCalendar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            draggingOver: false
        };
    }


    static getCalendarFormats() {
        return {
            dayHeaderFormat: "test",
            dayFormat: ` `,
            dateFormat: "test3"
        };
    }

    handleSelectEvent(eventTask) {
        this.props.onTaskClick(eventTask);
    }

    handleSelectSlot(slotInfo) {
        this.props.onPeriodSelectForCreate(slotInfo.start, slotInfo.end);
    }

    handleDrop(e) {
        e.preventDefault();

        this.setState({
            draggingOver: false
        });

        let data = JSON.parse(e.dataTransfer.getData("text/plain"));
        let startTime = "12:00";
        let endTime = "13:00";

        if (this.calendarRef) {
            let calRect = this.calendarRef.getBoundingClientRect();

            let offsetY = calRect.y;
            let dropY = e.clientY - offsetY;

            let hourSize = 200;
            let sizePerTenMins = hourSize / 6;
            let tenMinUnits = Math.round((dropY - 25) / sizePerTenMins);

            // Start time is: calendar start (6am) plus the amount of ten minute units based on Y coordinate
            let momentHelper = moment(`2001-01-01T06:00:00`);
            momentHelper.add(tenMinUnits * 10, "minutes");
            startTime = momentHelper.format(`HH:mm`);

            momentHelper.add(15, "minutes");
            endTime = momentHelper.format(`HH:mm`);
        }

        if (this.props.onEventInsert) {
            this.props.onEventInsert(data, startTime, endTime);
        }
    }

    handleDragOver(e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "copy";

        if (!this.state.draggingOver) {
            this.setState({
                draggingOver: true
            });
        }
    }

    handleDragEnd() {
        if (this.state.draggingOver) {
            this.setState({
                draggingOver: false
            });
        }
    }

    handleDragEnter(e) {
    }

    render() {
        let fnParseTime = (timeStr) => {
            let moment = SafeDateTimeParser.parseToMoment(timeStr);

            if (moment) {
                return moment.toDate();
            }

            return null;
        };

        let classNames = ["PlannerDayCalendar"];

        if (this.state.draggingOver) {
            classNames.push("PlannerDayCalendar--hotdrop");
        }

        return (
            <div
                className={classNames.join(' ')}
                onDrop={this.handleDrop.bind(this)} onDragOver={this.handleDragOver.bind(this)}
                onDragEnter={this.handleDragEnter.bind(this)}
                onDragEnd={this.handleDragEnd.bind(this)} onDragLeave={this.handleDragEnd.bind(this)}
                 onDragExit={this.handleDragEnd.bind(this)}
                ref={(ref) => this.calendarRef = ref}
            >
                <BigCalendar
                    events={this.props.tasks}
                    view={'day'}
                    date={moment('2001-01-01T00:00:00').toDate()}
                    toolbar={false}
                    showMultiDayTimes={false}
                    min={moment('2001-01-01T06:00:00').toDate()}
                    max={moment('2001-01-01T23:59:59').toDate()}
                    locale={'nl'}
                    formats={PlannerDayCalendar.getCalendarFormats()}
                    selectable={true}
                    titleAccessor={"name"}
                    startAccessor={(task) => { return fnParseTime(task.start_time); }}
                    endAccessor={(task) => { return fnParseTime(task.end_time); }}
                    onSelectEvent={this.handleSelectEvent.bind(this)}
                    onSelectSlot={this.handleSelectSlot.bind(this)}
                    timeslots={12}
                    step={5}
                />
            </div>
        );
    }
}

PlannerDayCalendar.propTypes = {
    tasks: PropTypes.array.isRequired,
    onTaskClick: PropTypes.func.isRequired,
    onPeriodSelectForCreate: PropTypes.func.isRequired,
    onEventInsert: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/Portal/Planner/PlannerDayCalendar.js